import React from "react";
import ReactDOM from "react-dom";
import { Toaster } from "react-hot-toast";
import reportWebVitals from "./reportWebVitals";
import { Route, Switch, BrowserRouter as Router } from "react-router-dom";
import { Paginas } from "./utils/PaginaUtils";
import { PagoAuthProvider } from "./context/PagoAuthContext";

//Styles
import "./assets/css/styles.css";
// import "./assets/css/main.css";

//Screens
import HomeScreen from "./screens/home/Home";

ReactDOM.render(
  <PagoAuthProvider>
    <Router>
      <Toaster position="top-right" />
      <Switch>
        <Route path={Paginas.HOME} component={HomeScreen} />
      </Switch>
    </Router>
  </PagoAuthProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
